export default __webpack_public_path__ + "img/fFodQVJQ.c390273e.svg";